const IDENTITY_LOCK_NAME = "node-client-device-identity";
let localTail = Promise.resolve();
export class BrowserIdentityLifecycleLock {
    async runExclusive(operation) {
        const locks = globalThis.navigator?.locks;
        if (locks !== undefined) {
            return await locks.request(IDENTITY_LOCK_NAME, operation);
        }
        return await runWithLocalLock(operation);
    }
}
async function runWithLocalLock(operation) {
    const previous = localTail;
    let release;
    localTail = new Promise((resolve) => {
        release = resolve;
    });
    await previous;
    try {
        return await operation();
    }
    finally {
        release?.();
    }
}
//# sourceMappingURL=identity-lock.js.map